import * as actionTypes from 'constants/ActionTypes';

export function getStatisticsCargoRequests(from, until) {
    return {
        type: actionTypes.GET_STATISTICS_CARGO_REQUESTS.REQUEST,
        from,
        until,
    };
}



// WEBPACK FOOTER //
// ./app/actions/statistics/cargoRequests.js